module.exports = __webpack_public_path__ + "static/media/daycation.2d0e8640.png";